import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=5cd1d587&"
import script from "./ShopInfo.vue?vue&type=script&lang=js&"
export * from "./ShopInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports